import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';

import { getServicios } from '../../services/ProductService';
import { addToCart } from '../../services/CartService';

import '../static/Inicio.css';
import '../static/Home.css';
import '../static/Productos.css';
import '../static/Global.css';
import '../static/Accordion.css';

import imagen1 from '../static/assets/collage1.jpg';
import imagen2 from '../static/assets/collage2.png';
import imagen3 from '../static/assets/collage3.jpg';
import imagen4 from '../static/assets/imagen1.jpg';
import imagen5 from '../static/assets/imagen2.jpg';
import imagen6 from '../static/assets/imagen3.jpg';


function Inicio() {
  const [servicios, setServicios] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [loading, setLoading] = useState(true);
  const [addedId, setAddedId] = useState(null);

  useEffect(() => {
    const fetchServicios = async () => {
      try {
        const data = await getServicios();
        setServicios(Array.isArray(data) ? data : []);
        setLoading(false);
      } catch (error) {
        console.error("Error cargando servicios:", error);
        setLoading(false);
      }
    };
    fetchServicios();
  }, []);

  // Filtrado de servicios por búsqueda de nombre o descripción
  const serviciosFiltrados = useMemo(() => {
    return servicios.filter(s => {
      if (!busqueda.trim()) return true;
      const term = busqueda.toLowerCase();
      const coincideNombre = s.nombre?.toLowerCase().includes(term);
      const coincideDesc = s.descripcion?.toLowerCase().includes(term);
      return coincideNombre || coincideDesc;
    });
  }, [servicios, busqueda]);

  const contactarPorWhatsApp = (servicio, e) => {
    if (e) e.stopPropagation();
    const mensaje = `Hola YCore, deseo solicitar información y cotización sobre el servicio: "${servicio.nombre}".`;
    const url = `https://wa.me/51906145083?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');
  };

  const scrollToGallery = () => {
    const galleryEl = document.getElementById('boutique-gallery');
    if (galleryEl) {
      galleryEl.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="boutique-layout">
      
      {/* --------------------------------------------------------
          1. HERO INMERSIVO / LOOKBOOK EDITORIAL
          -------------------------------------------------------- */}
      <section className="boutique-hero">
        <div id="boutiqueCarousel" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="5000">
          
          <div className="carousel-indicators boutique-indicators">
            <button type="button" data-bs-target="#boutiqueCarousel" data-bs-slide-to="0" className="active"></button>
            <button type="button" data-bs-target="#boutiqueCarousel" data-bs-slide-to="1"></button>
            <button type="button" data-bs-target="#boutiqueCarousel" data-bs-slide-to="2"></button>
          </div>

          <div className="carousel-inner">
            
            {/* Slide 1 */}
            <div className="carousel-item active">
              <div className="boutique-hero-bg" style={{ backgroundImage: `url(${imagen1})` }}>
                <div className="boutique-hero-overlay"></div>
              </div>
              <div className="boutique-hero-content">
                <span className="editorial-tag">SERVICIOS & SOLUCIONES</span>
                <h1 className="editorial-title">Innovación Digital a Tu Medida</h1>
                <p className="editorial-subtitle">Desarrollo de software, plataformas web e infraestructura tecnológica de alto rendimiento.</p>
                <div className="editorial-actions">
                  <button onClick={scrollToGallery} className="btn-boutique-primary">
                    Explorar Servicios
                  </button>
                </div>
              </div>
            </div>

            {/* Slide 2 */}
            <div className="carousel-item">
              <div className="boutique-hero-bg" style={{ backgroundImage: `url(${imagen2})` }}>
                <div className="boutique-hero-overlay"></div>
              </div>
              <div className="boutique-hero-content">
                <span className="editorial-tag">INGENIERÍA & DISEÑO</span>
                <h1 className="editorial-title">Soluciones Vanguardistas</h1>
                <p className="editorial-subtitle">Arquitectura escalable, interfaces modernas y herramientas creadas para potenciar tus clientes.</p>
                <div className="editorial-actions">
                  <button onClick={scrollToGallery} className="btn-boutique-primary">
                    Ver Catálogo de Servicios
                  </button>
                </div>
              </div>
            </div>

            {/* Slide 3 */}
            <div className="carousel-item">
              <div className="boutique-hero-bg" style={{ backgroundImage: `url(${imagen3})` }}>
                <div className="boutique-hero-overlay"></div>
              </div>
              <div className="boutique-hero-content">
                <span className="editorial-tag">ASESORÍA & CONSULTORÍA</span>
                <h1 className="editorial-title">Resultados que Transforman</h1>
                <p className="editorial-subtitle">Acompañamos cada etapa de tu transformación digital con atención y soporte personalizado.</p>
                <div className="editorial-actions">
                  <button onClick={scrollToGallery} className="btn-boutique-primary">
                    Cotizar Ahora
                  </button>
                </div>
              </div>
            </div>

          </div>

          <button className="carousel-control-prev boutique-nav-ctrl" type="button" data-bs-target="#boutiqueCarousel" data-bs-slide="prev">
            <span className="ctrl-line"><i className="fa-solid fa-arrow-left-long"></i></span>
          </button>
          <button className="carousel-control-next boutique-nav-ctrl" type="button" data-bs-target="#boutiqueCarousel" data-bs-slide="next">
            <span className="ctrl-line"><i className="fa-solid fa-arrow-right-long"></i></span>
          </button>

        </div>
      </section>

      {/* --------------------------------------------------------
          2. PILARES & SHOWCASE DE SERVICIOS
          -------------------------------------------------------- */}
      <section className="boutique-lookbook-strip">
        <div className="container-fluid px-lg-5">
          <div className="row g-4 align-items-center">
            
            <div className="col-12 col-md-4">
              <div className="lookbook-item">
                <div className="lookbook-img-box">
                  <img src={imagen4} alt="Desarrollo Web y Apps" className="lookbook-img" />
                </div>
                <div className="lookbook-caption">
                  <span className="lookbook-sub">DESARROLLO DE SOFTWARE</span>
                  <h5>Sistemas Web & Aplicativos</h5>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="lookbook-item item-featured">
                <div className="lookbook-img-box">
                  <img src={imagen5} alt="Infraestructura y Bases de Datos" className="lookbook-img" />
                </div>
                <div className="lookbook-caption">
                  <span className="lookbook-sub">ARQUITECTURA CLOUD</span>
                  <h5>Bases de Datos & Servidores</h5>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="lookbook-item">
                <div className="lookbook-img-box">
                  <img src={imagen6} alt="Consultoría Tecnológica" className="lookbook-img" />
                </div>
                <div className="lookbook-caption">
                  <span className="lookbook-sub">ASESORÍA TÉCNICA</span>
                  <h5>Consultoría & Soporte Especializado</h5>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* --------------------------------------------------------
          3. CATÁLOGO DE SERVICIOS
          -------------------------------------------------------- */}
      <section id="boutique-gallery" className="boutique-catalog-section">
        <div className="container">
          
          {/* Header de Galería Minimalista */}
          <div className="boutique-header-title text-center">
            <span className="gallery-tag">PORTAFOLIO DE SOLUCIONES</span>
            <h2 className="gallery-title">Nuestros Servicios</h2>
            <div className="title-divider"></div>
          </div>

          {/* Filtro y Búsqueda */}
          <div className="boutique-categories-bar" style={{ justifyContent: 'center' }}>
            {/* Búsqueda Discreta */}
            <div className="boutique-search-box" style={{ width: '100%', maxWidth: '420px' }}>
              <i className="fa-solid fa-magnifying-glass search-ico"></i>
              <input
                type="text"
                placeholder="Buscar servicio por nombre o detalle..."
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
                className="boutique-search-input"
              />
              {busqueda && (
                <button className="clear-ico-btn" onClick={() => setBusqueda('')}>
                  <i className="fa-solid fa-xmark"></i>
                </button>
              )}
            </div>
          </div>

          {/* Grilla Visual de Servicios */}
          <div className="boutique-grid-container pt-4">
            {loading ? (
              <div className="loader-wrapper">
                <div className="novatech-spinner"></div>
                <span className="loader-text">Cargando Servicios...</span>
              </div>
            ) : serviciosFiltrados.length === 0 ? (
              <div className="boutique-empty text-center py-5">
                <p>No se encontraron servicios en este momento.</p>
                {busqueda && (
                  <button 
                    className="btn-boutique-outline" 
                    onClick={() => setBusqueda('')}
                  >
                    Ver Todos los Servicios
                  </button>
                )}
              </div>
            ) : (
              <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4 g-xl-5">
                {serviciosFiltrados.map((servicio) => {
                  const isAdded = addedId === servicio.servicios_id;

                  return (
                    <div className="col" key={servicio.servicios_id}>
                      <article className="boutique-card">
                        
                        {/* Contenedor de Fotografía Principal */}
                        <div className="boutique-img-frame">
                          {servicio.imagen ? (
                            <img
                              src={servicio.imagen}
                              alt={servicio.nombre}
                              className="boutique-product-photo"
                              loading="lazy"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = imagen1;
                              }}
                            />
                          ) : (
                            <img
                              src={imagen1}
                              alt="Servicio YCore"
                              className="boutique-product-photo"
                              loading="lazy"
                            />
                          )}
                          
                          {/* Botón flotante para consultar por WhatsApp */}
                          <button
                            className="boutique-quick-buy"
                            onClick={(e) => contactarPorWhatsApp(servicio, e)}
                            title="Consultar por WhatsApp"
                            aria-label="Consultar por WhatsApp"
                            style={{ backgroundColor: '#25D366' }}
                          >
                            <i className="fa-brands fa-whatsapp"></i>
                          </button>

                          {/* Tag Sutil */}
                          <span className="boutique-pill-badge">Servicio</span>
                        </div>

                        {/* Metadatos Visuales */}
                        <div className="boutique-card-info">
                          <h3 className="boutique-title" title={servicio.nombre}>
                            {servicio.nombre}
                          </h3>
                          {servicio.descripcion && (
                            <p 
                              style={{ 
                                color: '#64748b', 
                                fontSize: '0.85rem', 
                                lineHeight: '1.4', 
                                marginTop: '6px',
                                display: '-webkit-box',
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden'
                              }}
                              title={servicio.descripcion}
                            >
                              {servicio.descripcion}
                            </p>
                          )}
                          
                          <div style={{ marginTop: '10px', display: 'flex', gap: '8px' }}>
                            <button
                              onClick={(e) => contactarPorWhatsApp(servicio, e)}
                              className="btn btn-outline-dark btn-sm rounded-pill w-100"
                              style={{ fontSize: '0.82rem', padding: '6px 12px', fontWeight: '500' }}
                            >
                              <i className="fa-brands fa-whatsapp me-1 text-success"></i> Cotizar Servicio
                            </button>
                          </div>
                        </div>

                      </article>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

        </div>
      </section>

      {/* --------------------------------------------------------
          4. MANIFIESTO EDITORIAL / STORYTELLING
          -------------------------------------------------------- */}
      <section className="boutique-manifesto">
        <div className="container">
          <div className="manifesto-card text-center">
            <span className="manifesto-tag">NUESTRA VISIÓN</span>
            <h2>"La excelencia tecnológica consiste en brindar soluciones elegantes, seguras y diseñadas para escalar con tu negocio."</h2>
            <div className="manifesto-author">— YCore Studio</div>
          </div>
        </div>
      </section>

      {/* --------------------------------------------------------
          5. FAQ BOUTIQUE MINIMALISTA
          -------------------------------------------------------- */}
      <section className="boutique-faq-section">
        <div className="container">
          <div className="text-center mb-5">
            <span className="gallery-tag">INFORMACIÓN & PROCESO</span>
            <h3 className="gallery-title" style={{ fontSize: '2rem' }}>Metodología & Garantía</h3>
            <div className="title-divider"></div>
          </div>

          <div className="row justify-content-center">
            <div className="col-12 col-lg-8">
              <div className="boutique-accordion">
                
                <details className="boutique-details">
                  <summary>
                    <span>¿Cómo se cotiza y contrata un servicio?</span>
                    <i className="fa-solid fa-plus"></i>
                  </summary>
                  <div className="boutique-details-body">
                    Evaluamos los requerimientos específicos de tu empresa o proyecto, elaboramos una propuesta técnica y económica con plazos claros, y formalizamos el inicio con entregables definidos.
                  </div>
                </details>

                <details className="boutique-details">
                  <summary>
                    <span>¿Ofrecen soporte y mantenimiento post-implementación?</span>
                    <i className="fa-solid fa-plus"></i>
                  </summary>
                  <div className="boutique-details-body">
                    Sí, todos nuestros desarrollos e implementaciones cuentan con período de garantía técnica y planes de mantenimiento preventivo y correctivo continuo.
                  </div>
                </details>

                <details className="boutique-details">
                  <summary>
                    <span>¿Los servicios son personalizados para cada cliente?</span>
                    <i className="fa-solid fa-plus"></i>
                  </summary>
                  <div className="boutique-details-body">
                    Totalmente. Diseñamos la arquitectura y las funcionalidades basándonos en los objetivos de tu negocio, garantizando máxima escalabilidad y seguridad.
                  </div>
                </details>

              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}

export default Inicio;